import axios from 'axios';
import router from '@/app-modules/router';

axios.interceptors.response.use((response) => response, (error) => {
    if (error.response.status === 401) {
      router.push('login');
    }
    return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/utils/axios-interceptors.ts